import React from 'react';

import InfoIcon from 'icons/info.svg';
import { useTranslation } from 'react-i18next';

import InfoPill from 'components/application/pills/InfoPill';

export default function LearnMoreInfoPill() {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <InfoPill
      className='tw-bg-teal-025 tw-text-teal-700'
      icon={
        <InfoIcon
          className='tw-mr-1.5 [&_path]:tw-fill-teal-700'
          height={12}
          width={12}
        />
      }
      text={
        <div className='tw-text-xs tw-font-semibold tw-tracking-wide'>
          {i18nTShared('learnMore')}
        </div>
      }
    />
  );
}
